export default "/images/vendor/flag-icon-css/flags/1x1/ms.svg?8f7c204278ae1cdcd35caa2bb55dacc7";